import { environment } from '../../environments/environment';
import { storage } from './storage';

/**
 * The curtain in front of the development site.
 *
 * Dev is a playground with the same face as the real thing, and a cortito made
 * there stops working the moment somebody wipes the database. So the dev build
 * asks for a key before it draws anything, and remembers the answer.
 *
 * It is deliberately not a lock. The key travels in the bundle that dev serves to
 * anybody who asks, so it can be read out of the JavaScript, and the database
 * keeps exactly the rules it always had — what this stops is somebody wandering
 * in, not somebody trying to get in. Production has no gate: `environment.dev` is
 * false there and every call below says yes.
 *
 * A short link is not gated either: `dev.corti.to/<alias>` still resolves, which
 * is the whole point of making one.
 */
const STORAGE_KEY = 'cortito-dev';

/** Whether the app may draw itself: always, unless this is dev and unanswered. */
export function gateOpen(): boolean {
  return !environment.dev || storage()?.getItem(STORAGE_KEY) === environment.devKey;
}

/** Tries a key, remembers it if it was the right one, and says whether it was. */
export function openGate(key: string): boolean {
  if (key.trim() !== environment.devKey) {
    return false;
  }
  storage()?.setItem(STORAGE_KEY, environment.devKey);
  return true;
}
